import { IComponentOptions } from "angular";
import { ContractInstanceContactComponentController } from "./controller";

export const vsComponentName = "contractInstanceContacts";

export const contractInstanceContactComponentOptions: IComponentOptions = {
  controller: ContractInstanceContactComponentController,
  controllerAs: "contactsController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    contract: "<",
  },
};
